import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import "./EditFlameDetectionFunctionality.html";

import EditFlameDetectionFunctionalityComponentController from "./EditFlameDetectionFunctionalityComponentController";

export default class EditFlameDetectionFunctionalityComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditFlameDetectionFunctionalityComponentController;

        // tslint:disable:max-line-length
        this.templateUrl =
            "/App/Components/Site/DesignAndPlanning/SelectedEquipment/CameraConfigurations/EditFlameDetectionFunctionality/EditFlameDetectionFunctionality.html";

        this.transclude = true;
    }
}

module("mmManagePortal").component("irEditFlameDetectionFunctionality", new EditFlameDetectionFunctionalityComponent());
